query soccerStatsperformPlayerMappings(
  $first: Int,
  $filter: SoccerPlayerMappingFilter,
) {
  allSoccerPlayerMappings(
    first: $first,
    filter: $filter
  ) {
    nodes {
      mappedEntity {
        playerId
      }
    }
  }
}
